import $ from 'jquery';
import { API_ROUTES } from "../../../helpers";
import { useState } from 'react';


export class ModalMetricsManager {

    showModalMetrics() {
        const modal = $('#deviceMetrics-' + this._deviceName)
        modal.removeClass('show')
        let deviceLabel = this._deviceLabel
        if (!deviceLabel) {
            deviceLabel = this._deviceName.replace('R_', '')
        }
        this.destroyCharts()

        $('#divMetrics7d', modal).addClass('d-none')
        $('#btnShowMetrics7d', modal).show()

        $('.modal-header h4', modal).text('Métriques pour ' + deviceLabel)
        this._buildCanvasMetrics('24h', this._deviceName)
        modal.addClass('show')
        modal.addClass('d-block')
    }

    closeModalMetrics() {
        const modal = $('#deviceMetrics-' + this._deviceName)
        modal.removeClass('show')
        modal.removeClass('d-block')
        this.destroyCharts()
        this._onModalClose()
    }

    showMetrics7d() {
        const modal = $('#deviceMetrics-' + this._deviceName)
        let deviceLabel = this._deviceLabel
        if (!deviceLabel) {
            deviceLabel = this._deviceName.replace('R_', '')
        }

        $('#divMetrics7d', modal).removeClass('d-none')
        $('#btnShowMetrics7d', modal).hide()
        this.canvasCharts['canvasMetrics7d'] ? this.canvasCharts['canvasMetrics7d'].destroy() : null

        this._buildCanvasMetrics('7d', this._deviceName)
    }

    _buildCanvasMetrics(deviceMetricDataGroup, deviceName) {
        const modal = $('#deviceMetrics-' + deviceName)
        if (deviceMetricDataGroup === '7d') {
            $('#divMetrics7d').removeClass('d-none')
        }
        $.get(API_ROUTES.DEVICES_METRICS, {
            deviceName: deviceName,
            groups: [deviceMetricDataGroup]
        }, (deviceMetrics) => {
            let dataLabels = null, dataPoints = [], chartLabels = [];
            const currentDeviceMetrics = deviceMetrics[deviceMetricDataGroup]
            Object.keys(currentDeviceMetrics).forEach((metricName) => {
                let currentDataLabels = [], currentDataPoints = []
                Object.keys(currentDeviceMetrics[metricName]).forEach((datetime) => {
                    const xLabel = deviceMetricDataGroup === '24h' ? datetime.substr(-5) : datetime.substr(-11)
                    currentDataLabels.push(xLabel)
                    currentDeviceMetrics[metricName][datetime] < 1 && !this._displayZeroValues ? currentDataPoints.push(null) : currentDataPoints.push(currentDeviceMetrics[metricName][datetime])
                })
                if (!dataLabels) {
                    dataLabels = currentDataLabels
                }
                dataPoints.push(currentDataPoints)
                chartLabels.push(metricName)
            })
            const canvasElement = $('.canvasMetrics' + deviceMetricDataGroup, modal)
            this._buildChart('line', canvasElement, dataLabels, dataPoints, true, chartLabels)

            setTimeout(() => {
                canvasElement.parent().parent().scrollLeft(10000)
            }, 500)
        })
    }


    _buildChart(chartType, canvasElement, dataLabels, dataPoints, useDataLabels = true, labels = null) {

        const options = { backgroundColor: '#2865a7' }
        let plugins = []
        if (useDataLabels === true) {
            options.plugins = {
                datalabels: {
                    color: 'black',
                    align: 'end',
                    anchor: 'end',
                    font: { weight: 'bold' },
                }
            }
            plugins = [ChartDataLabels]
        }
        options.pointBorderWidth = 6
        options.pointHoverBorderWidth = 12

        const backgroundColors = ['#2865a7', '#9b9338']
        let dataSets = []

        dataPoints.forEach((item, index) => {
            let dataLabelsCurrentData = {
                align: 'end',
                anchor: 'end',
                color: '#2865a7',
                offset: 5
            }
            if (index % 2 !== 0) {
                dataLabelsCurrentData = {
                    align: chartType === 'line' ? 'start' : 'end',
                    anchor: chartType === 'line' ? 'start' : 'end',
                    color: '#9b9338',
                    offset: 5
                }
            }
            dataSets.push({
                backgroundColor: backgroundColors[index],
                label: labels[index],
                data: dataPoints[index],
                borderColor: backgroundColors[index],
                fill: false,
                datalabels: dataLabelsCurrentData
            })
        })
        this.canvasCharts[canvasElement.attr('class')] ? this.canvasCharts[canvasElement.attr('class')].destroy() : null

        let barChart = new Chart(canvasElement, {
            type: chartType,
            plugins: plugins,
            data: {
                labels: dataLabels,
                datasets: dataSets,
            },
            options: options
        })
        this.canvasCharts[canvasElement.attr('class')] = barChart
        this._setCanvas(this.canvasCharts)
    }

    destroyCharts() {
        if (this.canvasCharts) {
            this.canvasCharts['canvasMetrics24h'] ? this.canvasCharts['canvasMetrics24h'].destroy() : null
            this.canvasCharts['canvasMetrics7d'] ? this.canvasCharts['canvasMetrics7d'].destroy() : null
        }
    }

}



export default function HousePilotModalMetrics({ deviceName, deviceLabel, showModal, onModalClose, displayZeroValues = false }) {

    const manager = new ModalMetricsManager()
    manager._deviceName = deviceName
    manager._deviceLabel = deviceLabel
    manager._onModalClose = onModalClose
    manager._displayZeroValues = displayZeroValues
    
    const stateCanvas = useState([])
    manager.canvasCharts = stateCanvas[0]
    manager._setCanvas = stateCanvas[1]

    if (showModal === true) {
        manager.showModalMetrics()
    }

    return (
        <>
            <div className="modal fade" id={"deviceMetrics-" + deviceName} role="dialog" aria-hidden="true" style={{ zIndex: "2" }}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header d-block text-center">
                            <h4></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => manager.closeModalMetrics()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <h5>Dernières 24H</h5>
                            <div className="mb-5" style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
                                <div style={{ width: "4000px", height: "300px" }} className='canvasContainer'>
                                    <canvas className="canvasMetrics24h" id={"canvas24H-" + deviceName} width="0" height="300"></canvas>
                                </div>
                            </div>
                            <h5>Derniers 7 Jours</h5>
                            <button type="button" className="btn btn-secondary" onClick={() => { $(this).hide(); manager.showMetrics7d() }} id="btnShowMetrics7d"> Afficher les stats sur 7 jours</button>
                            <div className="mb-5 d-none" style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }} id="divMetrics7d">
                                <div style={{ width: "4000px", height: "300px" }} className='canvasContainer'>
                                    <canvas className="canvasMetrics7d" id={"canvas7D-" + deviceName} width="0" height="300"></canvas>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer text-center mx-auto">
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => manager.closeModalMetrics()}>Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
